

export const sliderData  = [
    {image:"https://d32baadbbpueqt.cloudfront.net/Homepage/89e51326-1363-44e1-94f1-d5bd00bd2ca9.gif",
    heading: "",
    desc: "",
},

{image: "https://d32baadbbpueqt.cloudfront.net/Homepage/f190c764-84cf-4eea-a381-8b701be65852.gif",
heading: "",
desc: ""

},



{image: "https://d32baadbbpueqt.cloudfront.net/Homepage/af365bcc-d55a-453a-8829-58000d949593.gif",
heading: "",
desc: "",
},

{image:"https://d32baadbbpueqt.cloudfront.net/Homepage/a41d5b02-1299-4e1a-b4e1-ba19484796b5.gif",
heading: "",
desc: ""},

{image:"https://d32baadbbpueqt.cloudfront.net/Homepage/9f8fe6f9-3ebe-4d1b-9b15-d5e5e642868b.jpg",
heading: "",
desc: ""}
]




export const testData  = [
    {image:"https://d32baadbbpueqt.cloudfront.net/Homepage/b69d2fc2-53f5-45ed-8e89-8dcd108ed2b6.jpg",
    heading: "",
    desc: "",
},

{image: "https://d32baadbbpueqt.cloudfront.net/Homepage/1fb4eae2-6719-4f1f-b80e-efda1cf48362.jpg",
heading: "",
desc: ""

},

{image: "https://d32baadbbpueqt.cloudfront.net/Homepage/3b26e735-313c-4cc6-8b04-6b8febc55fe2.jpg",
heading: "",
desc: "",
}


]



